import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'plys-timer',
  imports: [CommonModule, TranslocoModule],
  templateUrl: './timer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./timer.component.scss'],
})
export class TimerComponent implements OnInit {
  @Input() time: number;
  @Input() expired = false;
  dutch: boolean;
  constructor(private translocoService: TranslocoService) {
    this.dutch = this.translocoService.getActiveLang() === 'nl';
  }
  ngOnInit(): void {}
}
